module.exports = __webpack_public_path__ + "img/opastuskeskus_original.4943e2e0.jpg";